jQuery('#myAffix').affix({offset: { top: 60 }});
